import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

const OPTIONS = {
  product: {
    breakpoints: {
      300: {
        slidesPerView: 1.2,
        spaceBetween: 12
      },
      500: {
        slidesPerView: 4.8,
        spaceBetween: 20

      },
    },
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    loop: true,
  },
  banner: {
    loop: true
  }
}
const MAIN_BANNER_CAROUSEL_SELECTOR = '.js-main-banner-carousel'
const MAIN_BANNER_LINK_SELECTOR = '.js-main-banner-link'
const PRODUCT_BANNER_SELECTOR = '[data-carousel-name="product"]'
const BACKGROUND_BANNER_SELECTOR = '[data-carousel-name="banner"]'
const ACTIVE_SWIPER_SLIDE_CLASS = 'swiper-slide-active'
const mainBannerCarouselElement = document.querySelector(
  MAIN_BANNER_CAROUSEL_SELECTOR
)
const mainBannerLinkElement = mainBannerCarouselElement?.querySelector(MAIN_BANNER_LINK_SELECTOR)
const DEFAULT_COLOR = '#D34DA5'
const DEFAULT_ROUTE = '/shop'

export async function initMainBannerCarousel() {
  if (!mainBannerCarouselElement) return
  const bannersCarousel = new Swiper(BACKGROUND_BANNER_SELECTOR, {
    ...OPTIONS.banner
  })
  const productsCarousel = new Swiper(PRODUCT_BANNER_SELECTOR, {...OPTIONS.product})
  productsCarousel.on('slideChange', (swiper) => {
    const swipeDirection = swiper.swipeDirection || 'next'
    if (swipeDirection === 'next') {
      bannersCarousel.slideNext()
    } else {
      bannersCarousel.slidePrev()
    }
    const productSlide = productsCarousel.slides.find(slide => slide.classList.contains(ACTIVE_SWIPER_SLIDE_CLASS))
    const productHref = productSlide?.dataset.productHref || DEFAULT_ROUTE
    mainBannerLinkElement.setAttribute('href', productHref)
    const bannerSlide = bannersCarousel.slides.find(slide => slide.classList.contains(ACTIVE_SWIPER_SLIDE_CLASS))
    const color = bannerSlide?.dataset.carouselColor || DEFAULT_COLOR
    mainBannerCarouselElement.setAttribute('style', `--banner-color:${color};`)
  })
}
